export let VECTOR_TYPES = function (VECTOR_TYPES) {
  VECTOR_TYPES[VECTOR_TYPES["FLOAT"] = 0] = "FLOAT";
  VECTOR_TYPES[VECTOR_TYPES["DATE"] = 1] = "DATE";
  return VECTOR_TYPES;
}({});
//# sourceMappingURL=types.js.map